
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/website-design",
      function () {
        return require("private-next-pages/services/website-design.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/website-design"])
      });
    }
  